import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataRules } from '@onefootprint/request-types/dashboard';
import { Divider, Shimmer } from '@onefootprint/ui';
import { useGetNodeConfigContext } from '../../hooks/use-get-node-config-context';
import type { NodeProps } from '../../playbook-builder.types';
import BaseNode from '../base-node';
import { AddDefaultRules } from '../shared/add-default-rules';
import type { DefaultRuleSet, GroupsToRemoveByCategory } from '../shared/rule-suggestion-context.types';
import { RemoveUnallowedGroups } from './components/remove-unallowed-groups';
import { RulesForm } from './components/rules-form';
import { isRulesWarning } from './hooks/use-rules-warning-messages';
const ERR_CODE_SUGGESTED_RULE_ADDITION = 'E134';
const ERR_CODE_SUGGESTED_RULE_DELETION = 'E135';
export const RulesNode = t0 => {
  const $ = _c(18);
  const {
    id,
    data
  } = t0;
  const config = useGetNodeConfigContext(id, "rules");
  let t1;
  if ($[0] !== id) {
    t1 = t2 => {
      const {
        error,
        mutation,
        type
      } = t2;
      const rs = error.context as DefaultRuleSet | undefined;
      if (!rs?.defaultRules) {
        return null;
      }
      return <AddDefaultRules error={error} type={type} ruleSet={rs} nodeId={id} mutation={mutation} variant="rules" />;
    };
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id) {
    t2 = t3 => {
      const {
        error: error_0,
        mutation: mutation_0,
        type: type_0
      } = t3;
      const rs_0 = error_0.context as GroupsToRemoveByCategory | undefined;
      if (!rs_0?.groups) {
        return null;
      }
      return <RemoveUnallowedGroups error={error_0} type={type_0} ruleSet={rs_0} nodeId={id} mutation={mutation_0} />;
    };
    $[2] = id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      [ERR_CODE_SUGGESTED_RULE_ADDITION]: t1,
      [ERR_CODE_SUGGESTED_RULE_DELETION]: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== config || $[8] !== data || $[9] !== id) {
    t4 = t5 => {
      const {
        mutation: mutation_1,
        canEdit
      } = t5;
      if (mutation_1.isPending || !config) {
        return <Loading />;
      }
      return <RulesForm data={data} nodeId={id} mutation={mutation_1} config={config} canEdit={canEdit} />;
    };
    $[7] = config;
    $[8] = data;
    $[9] = id;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      form: "rules-form",
      size: "lg",
      isBannerInline: isRulesWarning,
      customErrorComponents: t3,
      render: t4
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== data || $[15] !== id || $[16] !== t5) {
    t6 = <BaseNode nodeId={id} data={data} sidebar={t5} />;
    $[14] = data;
    $[15] = id;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
const Loading = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-2"><Shimmer width="76px" height="16px" /><Shimmer width="100%" height="32px" /></div>;
    t1 = <Divider />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-4 pb-4">{t0}{t1}<div className="flex flex-col gap-2"><Shimmer width="76px" height="16px" /><Shimmer width="100%" height="32px" /></div><Shimmer width="100%" height="120px" className="rounded" /><Shimmer width="100%" height="120px" className="rounded" /><Shimmer width="120px" height="32px" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};